import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import { db } from "@/db";
import { firestorePlugin } from "vuefire";
import { vuexfireMutations, firestoreAction } from "vuexfire";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: {
            id: null,
            name: null,
            email: null
        },        
        places: [],
        locale: null,
        error: null
    },
    mutations: {
        ...vuexfireMutations,
        
        SET_USER(state, user) {
            state.user = user
            state.token = user.token
        }
    },
    actions: {
        bindPlacesRefs: firestoreAction((context) => { 
            const url = process.env.NODE_ENV != 'development' ?
                        window.location.href.replace('#','').split('?')[0] :
                        'https://demo.prenotaevai.com/'
                        
            return context.bindFirestoreRef("places", db.collection("places").where('url', '==', url), { reset: false, wait: true })
        }),
        async createBooking({ state }, booking) {                        
            return new Promise((resolve, reject) => {
                db.collection('bookings')
                    .add(booking)
                    .then( docRef => resolve(docRef) )
                    .catch( error => reject(error) )
            })
        },
    },
    getters: {
        user: (state) => {
            return state.user
        },
        place: (state) => {
            // sort services slot by time            
            for (const [key, service] of Object.entries(state.places[0].services)) {
                const sorted = service.slots.sort((a,b) => a.localeCompare(b))
                state.places[0].services[key].slots = sorted
            }
            return state.places[0]
        },
        services: (state) => {
            return state.places[0].services
        },
        options: (state) => {
            return state.places[0].options
        }
    },
    modules: {}
})